/* Wayvz theme — global.js */
(function () {
  // Sticky header hairline on scroll
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () { links.classList.toggle('open'); });
  }

  // Toast helper (exposed for future add-to-cart wiring)
  var toastTimer;
  window.wayvzToast = function (msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    document.getElementById('toastMsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  // Keep the header cart count in sync with Shopify's live cart
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cartCount');
        if (!el) return;
        el.textContent = cart.item_count;
        el.classList.toggle('empty', cart.item_count === 0);
      })
      .catch(function () {});
  }
  refreshCartCount();
})();
